export default {
    title: "Catálogo",
    noAvailableItems: "Nenhum produto disponível para encomenda."
}